var map = {
	"./account_events.svg": "f1cb",
	"./account_info.svg": "1bdf",
	"./account_results.svg": "b743",
	"./add_plus.svg": "ab9d",
	"./add_plus_circle.svg": "6368",
	"./add_script.svg": "9b84",
	"./admin/avatar-borders.svg": "974e",
	"./admin/back.svg": "7753",
	"./admin/config_infra.svg": "3fcb",
	"./admin/connect_vm.svg": "517e",
	"./admin/deploy_infra.svg": "4fab",
	"./admin/filter.svg": "9246",
	"./admin/infra_busy.svg": "2be9",
	"./admin/infra_error.svg": "fd6c",
	"./admin/infra_idle.svg": "8963",
	"./admin/infra_lock.svg": "4407",
	"./admin/infra_process.svg": "e35c",
	"./admin/infra_unlock.svg": "f34c",
	"./admin/infrastructure.svg": "c4f8",
	"./admin/manual_slot.svg": "e17c",
	"./admin/menu_3d_editor.svg": "4cd9",
	"./admin/menu_admin.svg": "ac0e",
	"./admin/menu_audit.svg": "44b0",
	"./admin/menu_dashboard.svg": "4be8",
	"./admin/menu_editor.svg": "6563",
	"./admin/menu_event.svg": "a046",
	"./admin/menu_integrity.svg": "d989",
	"./admin/menu_lk.svg": "0cc1",
	"./admin/menu_mission.svg": "b2ab",
	"./admin/menu_results.svg": "d5ff",
	"./admin/menu_task.svg": "e754",
	"./admin/new_infrastructure.svg": "4054",
	"./admin/new_organization.svg": "0655",
	"./admin/new_user.svg": "e621",
	"./admin/organizations.svg": "6754",
	"./admin/scripts.svg": "e764",
	"./admin/selected_section_strip.svg": "eef1",
	"./admin/users.svg": "8e9e",
	"./arrow_circle.svg": "3afe",
	"./attention.svg": "44e0",
	"./audit.svg": "4e2e",
	"./avatar2.svg": "b5f5",
	"./back_triangle.svg": "5837",
	"./basket.svg": "1d02",
	"./battle.svg": "8d88",
	"./bots_menu.svg": "2977",
	"./breadcrumb_triangle.svg": "ceb8",
	"./briefcase.svg": "95b6",
	"./btn_scoreboard.svg": "a1a4",
	"./bug.svg": "937c",
	"./bulk_users.svg": "8a0e",
	"./calendar.svg": "287d",
	"./calendar_1.svg": "e348",
	"./calendar_menu.svg": "7714",
	"./cbr_checker.svg": "5d93",
	"./cbr_copy.svg": "fefc",
	"./cbr_event_observer.svg": "daf5",
	"./cbr_event_teacher.svg": "4ab9",
	"./cbr_event_team.svg": "1f33",
	"./cbr_event_users.svg": "e59d",
	"./change.svg": "1a94",
	"./change_label.svg": "73ff",
	"./change_label_en.svg": "70bd",
	"./chat/chat_menu.svg": "2905",
	"./chat/chat_menu_fill.svg": "d456",
	"./chat/chat_user_offline.svg": "ebb1",
	"./chat/chat_user_online.svg": "9763",
	"./chat/expand_chat.svg": "cb89",
	"./chat/expand_chat_2.svg": "3a13",
	"./chat/has_message.svg": "fdb0",
	"./chat/minimize_chat.svg": "d0e0",
	"./chat/minimize_chat_2.svg": "2c9e",
	"./chat/next.svg": "e122",
	"./chat/send_msg.svg": "88ae",
	"./check.svg": "a7c0",
	"./check_circle.svg": "cf7a",
	"./check_wo_pad.svg": "e8ef",
	"./checkbox_check.svg": "991c",
	"./checkbox_uncheck.svg": "5f62",
	"./checked_monitor.svg": "8eb5",
	"./circle_error.svg": "bcb4",
	"./circle_error_excl.svg": "4e8c",
	"./circle_ok.svg": "db40",
	"./clear_filter.svg": "8f21",
	"./clear_text.svg": "3766",
	"./clock.svg": "9f74",
	"./close_modal.svg": "71d9",
	"./comment_score.svg": "eb49",
	"./comment_tooltip.svg": "ce0a",
	"./console.svg": "ef9b",
	"./console_menu.svg": "421d",
	"./content_copy.svg": "24d3",
	"./continue_event.svg": "6255",
	"./corona.svg": "47e7",
	"./crib.svg": "51de",
	"./csv.svg": "fea6",
	"./cup_ctf.svg": "0215",
	"./cup_def.svg": "e179",
	"./cup_res.svg": "7adc",
	"./cup_sq.svg": "6fe7",
	"./cybermir_preloader_hud.svg": "d4a1",
	"./defence.svg": "a3a3",
	"./delete-icon.svg": "a727",
	"./delete_img.svg": "9678",
	"./delete_trash_can.svg": "3c4e",
	"./dialog_corner.svg": "4c73",
	"./down.svg": "1a4e",
	"./download_file.svg": "30f3",
	"./download_material.svg": "5872",
	"./download_w.svg": "b6f2",
	"./eng.svg": "651d",
	"./envelope.svg": "b422",
	"./envelope_email.svg": "32a7",
	"./error_hint.svg": "9f4f",
	"./error_modal.svg": "12b0",
	"./event/event_add_user.svg": "a3f4",
	"./event/event_check_targets.svg": "78a2",
	"./event/event_defence.svg": "269e",
	"./event/event_delete_user.svg": "f470",
	"./event/event_difficulty.svg": "db4a",
	"./event/event_disconnect_user_console.svg": "0a3c0",
	"./event/event_exercise.svg": "6ea6",
	"./event/event_observers.svg": "b0f5",
	"./event/event_quest.svg": "abe0",
	"./event/event_quest_list.svg": "faed",
	"./event/event_refresh_page.svg": "c5ae",
	"./event/event_round_duration.svg": "cdd0",
	"./event/event_slot.svg": "e724",
	"./event/event_slot_busy.svg": "6381",
	"./event/event_slot_selected.svg": "5f4f",
	"./event/event_total_observers.svg": "1291",
	"./event/event_total_users.svg": "518d",
	"./event/event_training.svg": "7c0b",
	"./event/event_type_ctf.svg": "18e4",
	"./event/event_type_defence.svg": "fb14",
	"./event/event_type_quest.svg": "9003",
	"./event/event_type_resistance.svg": "265f",
	"./event/event_user_report_unpublished_changes.svg": "1ac1",
	"./event/event_users.svg": "9bb9",
	"./event/event_vm_busy.svg": "5920",
	"./event/event_vm_free.svg": "6197",
	"./event/event_vms.svg": "2f4e",
	"./event/event_warning.svg": "3d78",
	"./event_bg_mask.svg": "5659",
	"./event_edit.svg": "85c6",
	"./event_err.svg": "fb56",
	"./event_materials.svg": "9562",
	"./event_start.svg": "7a10",
	"./event_target.svg": "57f2",
	"./event_teacher_error.svg": "6716",
	"./event_teacher_notification.svg": "dba7",
	"./event_type_flag.svg": "98a8",
	"./event_type_opposition.svg": "c34d",
	"./event_type_training.svg": "4cb8",
	"./event_users.svg": "456a",
	"./exit.svg": "a109",
	"./expand_minus.svg": "ea2d",
	"./expand_plus.svg": "d853",
	"./expansion_triangle.svg": "d9b1",
	"./export.svg": "8354",
	"./export_mission.svg": "cb3b",
	"./export_to_doc.svg": "b94c",
	"./eye_on_fire.svg": "805c",
	"./filter.svg": "3663",
	"./finish.svg": "13bb",
	"./flag.svg": "b238",
	"./hollow_clock.svg": "fb30",
	"./hollow_clock_12.svg": "d79c",
	"./hollow_clock_2.svg": "5bd9",
	"./hollow_duration.svg": "4395",
	"./hollow_shield.svg": "3c42",
	"./hollow_star.svg": "2a9a",
	"./human.svg": "50fb",
	"./import.svg": "1fb4",
	"./import_mission.svg": "7c5e",
	"./indicator_lamp.svg": "c8e4",
	"./info.svg": "b888",
	"./info_event.svg": "f246",
	"./info_fill.svg": "0b11",
	"./info_for_mission.svg": "2034",
	"./info_hint.svg": "03c9",
	"./info_ioc.svg": "eef5",
	"./info_light.svg": "06c4",
	"./integrity.svg": "c013",
	"./intersect.svg": "29b1",
	"./key_attack.svg": "e087",
	"./lamp.svg": "894c",
	"./last_report.svg": "947a",
	"./lk_empty_person.svg": "0c92",
	"./lk_empty_team.svg": "9ae6",
	"./lk_events_empty_1.svg": "b937",
	"./lk_events_empty_2.svg": "c5c1",
	"./lk_exp.svg": "fb8d",
	"./lk_face.svg": "22a1",
	"./lk_flag.svg": "c414",
	"./lk_ioc.svg": "4561",
	"./lk_srv_dis.svg": "df92",
	"./lk_srv_en.svg": "0271",
	"./lk_statuses.svg": "02f0",
	"./lk_task.svg": "932b",
	"./lk_type_ctf.svg": "e6bc",
	"./lk_type_def.svg": "78be",
	"./lk_type_res.svg": "64db",
	"./lk_type_sq.svg": "ecfa",
	"./lk_uses.svg": "08fb",
	"./loading.svg": "eede",
	"./lock.svg": "a012",
	"./log.svg": "9cb5",
	"./log_menu.svg": "5625",
	"./log_top_menu.svg": "1fe8",
	"./logo_login.svg": "e49b",
	"./logo_new.svg": "5a85",
	"./logo_new_en.svg": "48b5",
	"./logo_solar.svg": "fcad",
	"./logo_solar_cyber_en.svg": "917a",
	"./logo_solar_cyber_ru.svg": "3145",
	"./logo_solar_cybermir_eng_new.svg": "9d30",
	"./logo_solar_new.svg": "df68",
	"./lotus_position.svg": "ae4c",
	"./menu-highlight.svg": "2b81",
	"./mission/add.svg": "cc46",
	"./mission/add_plus.svg": "c303",
	"./mission/checkmark.svg": "1270",
	"./mission/checkmark_check.svg": "cf9e",
	"./mission/checkmark_uncheck.svg": "9a49",
	"./mission/copy.svg": "802c",
	"./mission/copy_copy.svg": "575a",
	"./mission/copy_disabled.svg": "0e70",
	"./mission/delete_trash.svg": "efcb",
	"./mission/document.svg": "bead",
	"./mission/document_orange.svg": "222a",
	"./mission/download.svg": "b37f",
	"./mission/download_disabled.svg": "facf",
	"./mission/edit.svg": "c86d",
	"./mission/edit_disabled.svg": "86c4",
	"./mission/edit_pencil.svg": "b20a",
	"./mission/empty.svg": "f424",
	"./mission/empty_border.svg": "d0cf",
	"./mission/error.svg": "ef75",
	"./mission/export.svg": "25f0",
	"./mission/group_title.svg": "d8ba",
	"./mission/import.svg": "9be6",
	"./mission/info.svg": "f309",
	"./mission/mission_menu.svg": "c3ad",
	"./mission/mission_quests.svg": "4c67",
	"./mission/mission_script_info.svg": "961b",
	"./mission/play.svg": "aa6d",
	"./mission/plus-for-scripts.svg": "698b",
	"./mission/reset.svg": "e012",
	"./mission/scripts.svg": "9d3c",
	"./mission/stages.svg": "c2fd",
	"./mission/time.svg": "58b2",
	"./mission/time_rounds.svg": "20df",
	"./mission/warning.svg": "36b2",
	"./mission/warning_new.svg": "684a",
	"./mission_filter_star.svg": "2009",
	"./mission_info.svg": "3144",
	"./mission_map.svg": "8c2e",
	"./mission_map_3d.svg": "0451",
	"./mission_map_3d_re.svg": "e8a2",
	"./mission_materials.svg": "83ee",
	"./module.svg": "a3a6",
	"./monitor.svg": "f71f",
	"./new.svg": "11d9",
	"./new_label.svg": "e2c2",
	"./new_label_en.svg": "4ccd",
	"./new_version.svg": "9d5e",
	"./notification_envelope.svg": "4efa",
	"./notification_sended.svg": "1db2",
	"./open_event.svg": "53e2",
	"./password_tip_area.svg": "5df5",
	"./pause_event.svg": "7562",
	"./pdf.svg": "8989",
	"./pencil.svg": "9255",
	"./play.svg": "4c1a",
	"./plus.svg": "701f",
	"./profile.svg": "d108",
	"./quest/quest_action_arrow.svg": "02df",
	"./quest/quest_back.svg": "7e04",
	"./quest/quest_changed_field.svg": "3525",
	"./quest/quest_collapse.svg": "0953",
	"./quest/quest_edited.svg": "fcc7",
	"./quest/quest_expand.svg": "2a66",
	"./quest/quest_finish.svg": "c544",
	"./quest/quest_needs_evaluation.svg": "aa57",
	"./quest/quest_report_completed_mark.svg": "101a",
	"./quest/quest_report_task_selector_error.svg": "1cbf",
	"./quest/quest_rollback.svg": "b07d",
	"./quest/quest_scored_field.svg": "9861",
	"./quest/quest_submit.svg": "9dc0",
	"./quest/quest_validation_error.svg": "d684",
	"./quest/quest_validation_info.svg": "e62f",
	"./quest/quest_validation_warning.svg": "b5a7",
	"./quest/quest_visualisation_gold_task.svg": "8c68",
	"./quest/quest_visualisation_gold_task_flash.svg": "0b7a",
	"./quest/quest_visualisation_quest_not_started.svg": "032f",
	"./quest/quest_visualization_arrows_1.svg": "e137",
	"./quest/quest_visualization_arrows_2.svg": "f702",
	"./quest/quest_visualization_arrows_3.svg": "dc3a",
	"./quest/quest_visualization_arrows_4.svg": "ca90",
	"./quest/quest_visualization_arrows_5.svg": "6d42",
	"./quest/quest_visualization_medal.svg": "ac6f",
	"./quest/quest_visualization_quest_completed.svg": "64b4",
	"./quest/quest_visualization_quest_pending_1.svg": "5362",
	"./quest/quest_visualization_quest_pending_10.svg": "5fc2",
	"./quest/quest_visualization_quest_pending_11.svg": "9b02",
	"./quest/quest_visualization_quest_pending_2.svg": "8ef3",
	"./quest/quest_visualization_quest_pending_3.svg": "f8d5",
	"./quest/quest_visualization_quest_pending_4.svg": "8c32",
	"./quest/quest_visualization_quest_pending_5.svg": "73d0",
	"./quest/quest_visualization_quest_pending_6.svg": "3557",
	"./quest/quest_visualization_quest_pending_7.svg": "cb5c",
	"./quest/quest_visualization_quest_pending_8.svg": "300c",
	"./quest/quest_visualization_quest_pending_9.svg": "51f5",
	"./quest/quest_visualization_stage_dots.svg": "7d63",
	"./quest/quest_visualization_total-score.svg": "0bb5",
	"./question.svg": "5d9e",
	"./reference_report.svg": "f36b",
	"./reload.svg": "8561",
	"./reload2.svg": "9253",
	"./reloadVm.svg": "9ac5",
	"./report.svg": "022e",
	"./reportMin.svg": "4c8b",
	"./report_grey.svg": "1271",
	"./report_star.svg": "f8ea",
	"./reports_list.svg": "3986",
	"./rhomb_list_marker.svg": "feb9",
	"./right_chevron_borders.svg": "64a8",
	"./ru.svg": "a6fc",
	"./run.svg": "dd3d",
	"./run_event.svg": "c001",
	"./save.svg": "b7b8",
	"./score.svg": "8fbd",
	"./score_cbr.svg": "dadc",
	"./scoreboard_arrow.svg": "0170",
	"./scoreboard_image_error.svg": "ca87",
	"./scoreboard_settings.svg": "6b6e",
	"./scoring.svg": "29c3",
	"./select_events.svg": "bc9e",
	"./self_learning.svg": "065c",
	"./send.svg": "45f4",
	"./send_disabled.svg": "e069",
	"./send_enabled.svg": "2b16",
	"./send_envelope.svg": "aad7",
	"./shield.svg": "07ad",
	"./shield_vs_bug.svg": "aa4d",
	"./slot.svg": "ba24",
	"./sort.svg": "6973",
	"./star_plus.svg": "d2c7",
	"./start_infrastructure.svg": "95c0",
	"./subtract.svg": "ce50",
	"./support_chat.svg": "a17d",
	"./tab_bg.svg": "e59b",
	"./tab_bg_active.svg": "88c7",
	"./task/task_add_plus_small.svg": "297a",
	"./task/task_assigned_by.svg": "09ed",
	"./task/task_attachment.svg": "7dbe",
	"./task/task_canceled.svg": "04aa",
	"./task/task_check_mark.svg": "286f",
	"./task/task_copy.svg": "212d",
	"./task/task_create_task_plus.svg": "5432",
	"./task/task_delete_cross.svg": "f4e3",
	"./task/task_delete_mission.svg": "725a",
	"./task/task_delete_tag.svg": "fb23",
	"./task/task_done.svg": "6fd9",
	"./task/task_double_arrow.svg": "4845",
	"./task/task_download.svg": "94b3",
	"./task/task_in_progress.svg": "b948",
	"./task/task_install_mission.svg": "8abb",
	"./task/task_link.svg": "fba2",
	"./task/task_link_plus.svg": "7b66",
	"./task/task_linked.svg": "37a1",
	"./task/task_mission_install_button.svg": "c1f1",
	"./task/task_missions_block.svg": "4b0b",
	"./task/task_no_assignee.svg": "8447",
	"./task/task_panel_arrow.svg": "53c5",
	"./task/task_plus.svg": "7945",
	"./task/task_plus_secondary.svg": "ff63",
	"./task/task_publish.svg": "af94",
	"./task/task_search.svg": "2ce4",
	"./task/task_send.svg": "2421c",
	"./task/task_send_to_assignee.svg": "6a73",
	"./task/task_status_canceled.svg": "b7d8",
	"./task/task_status_done.svg": "759d",
	"./task/task_status_in_progress.svg": "9cd6",
	"./task/task_status_unassigned.svg": "bdc8",
	"./task/task_table_arrow.svg": "0464",
	"./task/task_unassigned.svg": "f4bf",
	"./task/task_unlink.svg": "2e1d",
	"./teacher.svg": "3e85",
	"./tools/addlinepoint.svg": "bfc3",
	"./tools/addlinepoint_gray.svg": "4d9d",
	"./tools/arrowClosed.svg": "7d73",
	"./tools/arrowOpened.svg": "0673",
	"./tools/baseobj.svg": "6126",
	"./tools/camera.svg": "3e01",
	"./tools/centerpoint.svg": "fc24",
	"./tools/connect.svg": "5441",
	"./tools/coordX.svg": "eefc",
	"./tools/coordY.svg": "10e4",
	"./tools/cornerLeftBottom.svg": "fad7",
	"./tools/cornerLeftTop.svg": "692b",
	"./tools/cornerRightBottom.svg": "9028",
	"./tools/cornerRightTop.svg": "d22f",
	"./tools/cursor.svg": "8558",
	"./tools/delbtn.svg": "191f",
	"./tools/editplane.svg": "9135",
	"./tools/handmove.svg": "5d33",
	"./tools/icon.svg": "6c2d",
	"./tools/libPlus.svg": "e86a",
	"./tools/line.svg": "98b4",
	"./tools/locked.svg": "fe78",
	"./tools/menu.svg": "da9b",
	"./tools/menuAddComponent.svg": "2e83",
	"./tools/menuAddGif.svg": "a265",
	"./tools/menuAddIcon.svg": "f08d",
	"./tools/menuAppendConfig.svg": "f7c8",
	"./tools/menuNewConfig.svg": "c135",
	"./tools/menuOpenConfig.svg": "9fc1",
	"./tools/menuSaveConfig.svg": "6f97",
	"./tools/movecursor.svg": "441a",
	"./tools/plane.svg": "dcd0",
	"./tools/rotateAngle.svg": "3407",
	"./tools/skewAngle.svg": "a794",
	"./tools/text.svg": "2242",
	"./tools/toBack.svg": "be37",
	"./tools/toFront.svg": "1783",
	"./tools/typeEssence.svg": "91ac",
	"./tools/typeLine.svg": "a78f",
	"./tools/typePlane.svg": "dd98",
	"./tools/typeText.svg": "66fb",
	"./tools/unlocked.svg": "dcc6",
	"./topology.svg": "85ca",
	"./trash_can.svg": "6b57",
	"./triangle_left.svg": "0222",
	"./triangle_left_changed.svg": "699c",
	"./triangle_left_edge.svg": "86cd",
	"./triangle_right.svg": "6d04",
	"./uikit/1st.svg": "9afd",
	"./uikit/2nd.svg": "1f11",
	"./uikit/3rd.svg": "b1b0",
	"./uikit/Person.svg": "99f1",
	"./uikit/attack.svg": "b90c",
	"./uikit/base_expand_arrow.svg": "4116",
	"./uikit/btn/cancel.svg": "ebeb",
	"./uikit/btn/cantSend.svg": "4bc3",
	"./uikit/btn/cbr-action-menu-inverted.svg": "28f0",
	"./uikit/btn/cbr-action-menu.svg": "0fe5",
	"./uikit/btn/cbr-arrow-left-small.svg": "a98f",
	"./uikit/btn/cbr-assign-user.svg": "e44e",
	"./uikit/btn/cbr-cancel.svg": "527b",
	"./uikit/btn/cbr-close.svg": "bc2f",
	"./uikit/btn/cbr-copy-link.svg": "e34a",
	"./uikit/btn/cbr-finish.svg": "ad0e",
	"./uikit/btn/cbr-pause.svg": "1f3a",
	"./uikit/btn/cbr-pc-play.svg": "8525",
	"./uikit/btn/cbr-play.svg": "344e",
	"./uikit/btn/cbr-plus-circle-18.svg": "8f2a",
	"./uikit/btn/cbr-quest-arrow-left.svg": "d87d",
	"./uikit/btn/cbr-quest-arrow-right.svg": "1d3a",
	"./uikit/btn/cbr-save.svg": "7ce8",
	"./uikit/btn/cbr-start.svg": "65a8",
	"./uikit/btn/cbr-stop.svg": "0b79",
	"./uikit/btn/delete.svg": "ab34",
	"./uikit/btn/download.svg": "1518",
	"./uikit/btn/edit.svg": "2212",
	"./uikit/btn/log.svg": "d366",
	"./uikit/btn/new-user.svg": "898d",
	"./uikit/btn/plus-circle.svg": "b957",
	"./uikit/btn/plus.svg": "cf6a",
	"./uikit/btn/push.svg": "73f9",
	"./uikit/btn/refresh.svg": "2e7e",
	"./uikit/btn/send.svg": "1d87",
	"./uikit/btn/set.svg": "633c",
	"./uikit/btn/settings.svg": "cf93",
	"./uikit/btn/software.svg": "f1ab",
	"./uikit/btn/upload-xls.svg": "c380",
	"./uikit/cbr-alarm-hint.svg": "c5db",
	"./uikit/cbr-error.svg": "8760",
	"./uikit/cbr-file.svg": "f435",
	"./uikit/cbr-info.svg": "71b8",
	"./uikit/cbr-information.svg": "9e4d",
	"./uikit/cbr-plus.svg": "a252",
	"./uikit/cbr-quest-down.svg": "d554",
	"./uikit/cbr-quest-result.svg": "65ad",
	"./uikit/cbr-quest-test.svg": "3faa",
	"./uikit/cbr-quest-vizualization.svg": "0b1c",
	"./uikit/circle_plus.svg": "3cce",
	"./uikit/datepicker.svg": "ea04",
	"./uikit/datepicker_arrow_left.svg": "8148",
	"./uikit/datepicker_arrow_right.svg": "e097",
	"./uikit/down_arrow.svg": "ee5c",
	"./uikit/drop-files-plus.svg": "bede",
	"./uikit/home.svg": "c5aa",
	"./uikit/info.svg": "4766",
	"./uikit/input-reset.svg": "42e3",
	"./uikit/menu_open.svg": "838e",
	"./uikit/menu_open_triangle.svg": "9808",
	"./uikit/open_email.svg": "5f2b",
	"./uikit/organization-block-user.svg": "c2d8",
	"./uikit/organization-internal.svg": "5dd2",
	"./uikit/organization.svg": "dd47",
	"./uikit/required_m.svg": "4e55",
	"./uikit/script.svg": "a240",
	"./uikit/sorting-active.svg": "e3de",
	"./uikit/sorting.svg": "120c",
	"./uikit/up_arrow.svg": "de80",
	"./up.svg": "bc3e",
	"./update.svg": "10e6",
	"./update_data.svg": "a886",
	"./updown.svg": "c227",
	"./upload.svg": "068c",
	"./user_edit.svg": "86eb",
	"./user_item.svg": "1375",
	"./user_item_b.svg": "86f7",
	"./users_group.svg": "b871",
	"./users_group_b.svg": "a8bb",
	"./vector.svg": "80ff",
	"./vm.svg": "41ff",
	"./warning.svg": "0d95",
	"./warning_hint.svg": "30a0",
	"./warning_login.svg": "5a6a",
	"./warning_triangle.svg": "3be0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a601";